// extracted by mini-css-extract-plugin
module.exports = {"colMaxWidth":"Table_colMaxWidth__3dGol"};